export default __webpack_public_path__ + "static/netskope-f325f21424d3094947b49532137d4060.jpg";